<template>
  <div class="schedule" :class="{ 'schedule--preview': isPreview }">
    <!-- Aperçu (route avec cryptext) : affichage dans une fenêtre pour voir tout l'écran -->
    <div v-if="isPreview" class="main-container" :style="{ width: previewWidth }">
      <div class="main-container__card">
        <div class="main-container__card__header">
          <p class="title_template">{{ previewTitle }}</p>
        </div>
        <div class="iframe-container" :style="{ width: previewWidth, height: previewHeight }">
          <iframe v-if="currentSrc" class="current-template" :src="iframeSrc"></iframe>
        </div>
      </div>
    </div>
    <iframe v-else-if="currentSrc" class="current-template" :src="iframeSrc"></iframe>
  </div>
</template>
<script>
import Routing from '../../core/router/router';
import { HTTP } from '../../core/http/http-token';

export default {
  data() {
    return {
      templates: {},
      currentIndexTemplate: 0,
      currentSrc: null,
      loop: false,
      indexNextTemplate: 0,
      sockets: [],
      wsClosing: false,
      reloadToken: 0,
      previewWidth: '37.5vw',
      previewHeight: '30vw',
      previewTitle: 'Loading...',
    };
  },
  props: {
    isRmBox: Boolean,
  },
  computed: {
    isPreview() {
      return !!this.$route.params.cryptext;
    },
    currentTemplateId() {
      let current = Array.isArray(this.templates) && this.templates[this.currentIndexTemplate];
      return current ? current.id : null;
    },
    iframeSrc() {
      if (!this.currentSrc) {
        return null;
      }
      if (this.reloadToken === 0) {
        return this.currentSrc;
      }
      // Cache-buster pour forcer le rechargement de l'iframe sur message WebSocket "reload"
      let separator = this.currentSrc.indexOf('?') === -1 ? '?' : '&';
      return this.currentSrc + separator + '_reload=' + this.reloadToken;
    },
  },
  watch: {
    currentTemplateId(id) {
      if (this.isPreview && id !== null && id !== undefined) {
        this.loadPreviewInfos(id);
      }
    },
  },
  methods: {
    loadPreviewInfos(templateId) {
      let self = this;
      let token = window.ApiToken
        ? window.ApiToken
        : 'Bearer ' +
          ((window.process && window.process.env && window.process.env.API_TOKEN) ||
            localStorage.getItem('authToken'));
      HTTP(token)
        .get(Routing.generate('api_templateDisplay_get_template_urls', { id: templateId }))
        .then(
          function(response) {
            let data = response.data && response.data.data;
            if (!data || String(templateId) !== String(self.currentTemplateId)) {
              return;
            }
            self.previewTitle = data.title || '';
            let device = data.display_devices && data.display_devices[0];
            if (device) {
              self.previewWidth = device.width;
              self.previewHeight = device.height;
            }
          },
          function() {
            // En cas d'échec on garde les dimensions par défaut
            self.previewTitle = '';
          },
        );
    },
    // Ouvre les WebSockets : un seul par rmbox (rmboxId) sur la route show-schedule-by-rmbox,
    // sinon un par template retourné par l'API (templateId = template.id)
    initWebSockets() {
      let self = this;
      self.closeWebSockets();
      self.wsClosing = false;
      if (self.isRmBox) {
        // L'id de la route peut être suffixé (ex: "1-bo") : on ne garde que la partie numérique
        let routeId = self.$route.params.id;
        let rmboxId =
          routeId !== undefined && routeId !== null ? String(routeId).split('-')[0] : routeId;
        if (rmboxId !== undefined && rmboxId !== null && rmboxId !== '') {
          self.openSocket({ rmboxId: rmboxId });
        }
        return;
      }
      let templates = Array.isArray(self.templates) ? self.templates : [];
      let seen = {};
      templates.forEach(function(template) {
        let templateId = template && template.id;
        if (templateId === undefined || templateId === null || seen[templateId]) {
          return;
        }
        seen[templateId] = true;
        self.openSocket({ templateId: templateId });
      });
    },
    openSocket(target) {
      let self = this;
      // Fallback en dur si env-config.js (servi au runtime) n'expose pas encore WS_RELAY_URL
      let baseUrl =
        (window.process && window.process.env && window.process.env.WS_RELAY_URL) ||
        'wss://ws-relay.webtv.workers.dev/ws';
      let clientName =
        (window.process && window.process.env && window.process.env.CLIENT_NAME) || '';
      // En mode rmbox on connecte avec rmboxId, sinon avec templateId
      let queryParam =
        target.rmboxId !== undefined && target.rmboxId !== null
          ? 'rmboxId=' + encodeURIComponent(target.rmboxId)
          : 'templateId=' + encodeURIComponent(target.templateId);
      let url = baseUrl + '?' + queryParam + '&clientName=' + encodeURIComponent(clientName);
      let socket = { target: target, ws: null, reconnectTimer: null };
      self.sockets.push(socket);
      let connect = function() {
        if (self.wsClosing) {
          return;
        }
        try {
          socket.ws = new WebSocket(url);
        } catch (e) {
          self.scheduleReconnect(socket, connect);
          return;
        }
        socket.ws.onmessage = function(event) {
          let payload = event.data;
          try {
            payload = JSON.parse(event.data);
          } catch (e) {
            // message non-JSON : on garde la valeur brute
          }
          let type = payload && typeof payload === 'object' ? payload.type : payload;
          if (type === 'reload') {
            if (target.rmboxId !== undefined) {
              // En mode rmbox : on rappelle l'API pour récupérer le templateHtml mis à jour
              // et le réinjecter dans l'iframe.
              self.refreshTemplatesFromApi();
            } else if (self.isCurrentTemplate(target.templateId)) {
              // Sinon on ne recharge que si le message concerne le template affiché.
              self.reloadIframe();
            }
          }
        };
        socket.ws.onclose = function() {
          socket.ws = null;
          if (!self.wsClosing) {
            self.scheduleReconnect(socket, connect);
          }
        };
        socket.ws.onerror = function() {
          if (socket.ws) {
            socket.ws.close();
          }
        };
      };
      connect();
    },
    scheduleReconnect(socket, connect) {
      let self = this;
      if (self.wsClosing || socket.reconnectTimer) {
        return;
      }
      socket.reconnectTimer = setTimeout(function() {
        socket.reconnectTimer = null;
        connect();
      }, 5000);
    },
    isCurrentTemplate(templateId) {
      let current = this.templates && this.templates[this.currentIndexTemplate];
      return !!current && String(current.id) === String(templateId);
    },
    closeWebSockets() {
      this.wsClosing = true;
      this.sockets.forEach(function(socket) {
        if (socket.reconnectTimer) {
          clearTimeout(socket.reconnectTimer);
          socket.reconnectTimer = null;
        }
        if (socket.ws) {
          socket.ws.close();
          socket.ws = null;
        }
      });
      this.sockets = [];
    },
    reloadIframe() {
      this.reloadToken++;
    },
    // En mode rmbox : récupère à nouveau la liste des templates via l'API pour obtenir
    // le templateHtml mis à jour, puis le réinjecte dans l'iframe (avec cache-buster).
    refreshTemplatesFromApi() {
      let self = this;
      let token =
        'Bearer ' + (window.process && window.process.env && window.process.env.API_TOKEN);
      let data = { idRmbox: this.$route.params.id };
      HTTP(token)
        .get(Routing.generate('api_templateDisplay_get_templates_by_rmbox', data))
        .then(
          function(response) {
            let templates = (response.data && response.data.data && response.data.data.templates) || [];
            self.templates = templates;
            if (self.currentIndexTemplate >= templates.length) {
              self.currentIndexTemplate = 0;
            }
            let current = templates[self.currentIndexTemplate];
            if (current) {
              self.currentSrc = current.templateHtml;
            }
            // Force le rechargement de l'iframe même si l'URL du templateHtml est inchangée.
            self.reloadIframe();
          },
          function() {
            // En cas d'échec on garde l'affichage courant
          },
        );
    },
    updateTemplate() {
      let self = this;
      let interval = 0;
      self.currentIndexTemplate++;
      let dateCurrent = new Date();
      var inf_interval = new Date(self.templates[self.currentIndexTemplate].start_date).getTime();
      if (self.currentIndexTemplate - 1 !== self.templates.length) {
        self.currentSrc = self.templates[self.currentIndexTemplate].templateHtml;
        var duration = self.templates[self.currentIndexTemplate].duration_template * 1000;
        if (self.currentIndexTemplate + 1 !== self.templates.length) {
          var sup_interval = new Date(
            self.templates[self.currentIndexTemplate + 1].start_date,
          ).getTime();
          if (
            self.getDateString(self.templates[self.currentIndexTemplate].start_date) <
            self.getDateString('now')
          ) {
            self.loop = false;
            var new_index = self.searchTemplateDay(self.getDateString('now'), self.templates);
            if (new_index) {
              self.currentIndexTemplate = new_index - 1;
              sup_interval = new Date().getTime();
            } else {
              self.currentIndexTemplate = self.indexNextTemplate - 1;
              sup_interval = new Date(
                self.templates[self.currentIndexTemplate + 1].start_date,
              ).getTime();
            }
            inf_interval = new Date().getTime();
          } else if (
            self.getDateString(self.templates[self.currentIndexTemplate + 1].start_date) >
            self.getDateString('now')
          ) {
            self.indexNextTemplate = self.currentIndexTemplate + 1;
            if (
              self.searchTemplateDay(self.getDateString('now'), self.templates) !==
              self.currentIndexTemplate
            ) {
              self.currentIndexTemplate =
                self.searchTemplateDay(self.getDateString('now'), self.templates) - 1;
              self.loop = true;
            }
          }

          if (self.loop) {
            interval = duration;
          } else {
            interval = sup_interval - inf_interval;
          }
          setTimeout(self.updateTemplate, interval);
        }
      }
    },
    getDateString(date) {
      if (date === 'now') {
        var mydate = new Date();
      } else {
        var mydate = new Date(date);
      }
      var dd = String(mydate.getDate()).padStart(2, '0');
      var mm = String(mydate.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = mydate.getFullYear();

      mydate = yyyy + '-' + mm + '-' + dd;
      return mydate;
    },
    searchTemplateDay(day, myArray) {
      let self = this;
      for (var i = 0; i < myArray.length; i++) {
        if (
          self.getDateString(myArray[i].start_date) <= day &&
          day <= self.getDateString(myArray[i].end_date)
        ) {
          return i;
        }
      }
    },
    ajaxCallApi() {
      let self = this;
      let token =
        'Bearer ' + (window.process && window.process.env && window.process.env.API_TOKEN);
      let apiDisplayTemplates = this.isRmBox
        ? 'api_templateDisplay_get_templates_by_rmbox'
        : 'api_templateDisplay_get_templates_by_program';
      let interval = 0;
      let intervalAjax = 0;
      let data = this.isRmBox
        ? {
            idRmbox: this.$route.params.id,
          }
        : {
            idProgram: this.$route.params.id,
          };
      HTTP(token)
        .get(Routing.generate(apiDisplayTemplates, data))
        .then(
          function(response) {
            self.templates = response.data.data.templates;
            self.currentIndexTemplate = 0;
            self.currentSrc = self.templates[self.currentIndexTemplate].templateHtml;
            // Ouvre un WebSocket par template une fois la liste chargée
            self.initWebSockets();

            if (self.templates.length > 1) {
              interval =
                new Date(self.templates[self.currentIndexTemplate + 1].start_date).getTime() -
                new Date().getTime();
              setTimeout(self.updateTemplate, interval);
            }
            var dayOfWeek = 6;
            var date = new Date();
            date.setHours(23, 55, 0, 0);
            date.setDate(date.getDate() + ((dayOfWeek + 7 - date.getDay()) % 7));
            intervalAjax = date.getTime() - new Date().getTime();
            setTimeout(self.ajaxCallApi, intervalAjax);
          },
          function(response) {
            //self.hideLoader();
          },
        );
    },
  },
  created() {
    let self = this;
    self.ajaxCallApi();
  },
  beforeDestroy() {
    this.closeWebSockets();
  },
};
</script>
<style lang="scss" scoped>
.schedule {
  margin: 0;
  height: 100%;
  width: 100%;

  .current-template {
    height: 100%;
    width: 100%;
    border: 0;
  }

  &--preview {
    height: auto;
    min-height: 100%;
    padding: 8px 0;
    box-sizing: border-box;
    background: #fff;

    .main-container {
      margin: 0 auto;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

      &__card {
        border: 1px solid #c3c3c3;
        border-radius: 2px;

        &__header {
          background: #eeeeee;
          display: flex;
          align-items: center;
        }
      }
    }

    .title_template {
      margin: 0;
      padding: 10px;
      font-family: 'Times New Roman', Times, serif;
      font-size: 16px;
      color: #000;
    }

    .iframe-container {
      overflow: hidden;
      position: relative;
    }

    .current-template {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Schedule.vue?2692a8fd